import { useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { SxProps } from '@mui/material';

import { triggerLogout } from '@atom/actions/userActions';
import { useNavigation } from '@atom/hooks/useNavigation';
import { useUserProfile } from '@atom/hooks/useUserProfile';
import defaultProfileImage from '@atom/images/defaultProfileImage.png';
import { Icon, Popover } from '@atom/mui';
import {
  AccountCircleIcon,
  ExitToAppIcon,
  HelpOutlineIcon,
} from '@atom/mui/icons';
import { knowledgeCenterLinkSelector } from '@atom/selectors/preferencesSelectors';
import colors from '@atom/styles/colors';

import classes from './navigation.module.css';

const styles = {
  iconStyle: {
    color: colors.neutral.gray,
    marginRight: '1rem',
  },
};

const sx: SxProps = {
  right: 0,
  width: '14.75rem',
  left: 'auto',
  padding: '0.5rem 0',
  borderRadius: '0.25rem',
  boxShadow: `0 0.125rem 0.5rem ${colors.utility.boxShadow}`,
};

const Profile = () => {
  const [, { navigate }] = useNavigation();
  const userProfile = useUserProfile();
  const knowledgeCenterLink = useSelector(knowledgeCenterLinkSelector);
  const dispatch = useDispatch();
  const anchor = useRef<HTMLDivElement>(null);

  const [open, setOpen] = useState<boolean>(false);

  const handleLogout = () => {
    setOpen(false);
    dispatch(triggerLogout());
  };

  const handleKnowledgeCenterClick = () => {
    setOpen(false);
    window.open(knowledgeCenterLink, '_blank', 'noopener');
  };

  const handleProfileClick = () => {
    setOpen(false);
    navigate(`/team/${userProfile.userId}`);
  };

  return (
    <div className={classes.profileWrapper} ref={anchor}>
      <img
        className={classes.profile}
        onClick={() => setOpen(true)}
        data-cy="profileMenuButton"
        src={userProfile.profileImage}
        onError={(error: any) => {
          error.target.src = defaultProfileImage;
        }}
      />
      <Popover
        open={open}
        anchorEl={anchor.current}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        onClose={() => setOpen(false)}
        slotProps={{ paper: { sx } }}
      >
        <div
          className={classes.menuRow}
          onClick={handleProfileClick}
          data-cy="profileMenuUserProfile"
        >
          <Icon style={styles.iconStyle} icon={AccountCircleIcon} />
          User Profile
        </div>
        <div
          className={classes.menuRow}
          onClick={handleKnowledgeCenterClick}
          data-cy="profileMenuKnowledgeCenter"
        >
          <Icon style={styles.iconStyle} icon={HelpOutlineIcon} />
          Knowledge Center
        </div>
        <div
          className={classes.menuRow}
          onClick={handleLogout}
          data-cy="profileMenuLogOut"
        >
          <Icon style={styles.iconStyle} icon={ExitToAppIcon} />
          Log Out
        </div>
      </Popover>
    </div>
  );
};

export default Profile;
